import { useEffect } from 'react';
import { cacheUtils } from '../../helpers/cacheUtils';

export const useCacheControl = () => {
  useEffect(() => {
    // Set cache control headers for the current page
    const setPageCacheHeaders = () => {
      const path = window.location.pathname;
      
      // Apply different cache strategies based on route
      if (path.includes('/user') || path.includes('/role')) {
        // Admin pages - no cache
        document.querySelector('meta[http-equiv="Cache-Control"]')?.remove();
        const meta = document.createElement('meta');
        meta.httpEquiv = 'Cache-Control';
        meta.content = 'no-cache, no-store, must-revalidate';
        document.head.appendChild(meta);
      } else if (path === '/' || path.includes('/dashboard')) {
        // Dashboard - short cache
        document.querySelector('meta[http-equiv="Cache-Control"]')?.remove();
        const meta = document.createElement('meta');
        meta.httpEquiv = 'Cache-Control';
        meta.content = 'public, max-age=300';
        document.head.appendChild(meta);
      }
    };

    setPageCacheHeaders();
    
    // Listen for route changes
    const handleRouteChange = () => {
      setPageCacheHeaders();
    };

    window.addEventListener('popstate', handleRouteChange);
    
    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  return {
    clearAuthCache: cacheUtils.clearAuthCache,
    secureAuthFetch: cacheUtils.secureAuthFetch,
    withCache: cacheUtils.withCache,
    withoutCache: cacheUtils.withoutCache
  };
};